import { Box } from "@mui/system";
import { useState, useEffect, useCallback } from "react";
import {
  addUserInformation,
  personalData,
  updateStatus,
  userStaffProfile,
} from "../../services/user";
import Title from "../../components/Dashboard/Title";
import colors from "../../assets/colors.json";
import {
  SmallHeader,
  TabContainer,
  TabContent,
  TabLink,
  TabLinkContainer,
} from "./styles/dashboard.style";
import {
  Personal,
  Experience,
  Certifications,
  NOK,
  UserInformation,
} from "../../components/profile";
import ErrorService from "../../services/errorService";
import { toast } from "react-toastify";
import GlobalStyles from "../../assets/globalStyle";
import { useSelector } from "react-redux";
import Loader from "../../components/pageLoader/loader";
import { TeacherClasses } from "../../services/Subject";
import EmployeeReferenceForm from "../../components/profile/ReferenceForm";
import AttachmentsSection from "../../components/profile/Attachment";
import Request from "../../components/profile/requests/Request";
import TableLoader from "../../components/TableLoader";

const Profile = () => {
  const { admToken, user } = useSelector((state) => state.auth);
  const [tab, setTab] = useState(6);
  const [bioData, setBioData] = useState(null);
  const [accountStatus, setAccountStatus] = useState(null);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingBioData, setLoadingBioData] = useState(true);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const [loadingUploading, setLoadingUploading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  let defaultEduObj = {
    school: "",
    course: "",
    degree: "",
    grade: "",
    startDate: "",
    endDate: "",
    comments: "",
    proofFileBase64: "",
  };
  const [eduObj, setEduObj] = useState(defaultEduObj);

  let defaultExpObj = {
    employer: "",
    position: "",
    empPhoneNumber: "",
    empEmail: "",
    startDate: "",
    empAddress: "",
    endDate: "",
    reasons: "",
    current: false,
  };

  // const [expObj, setExpObj] = useState(defaultExpObj);

  let defaultCertObj = {
    institution: "",
    courseName: "",
    licenseName: "",
    issueingBody: "",
    startDate: "",
    endDate: "",
    proofFileBase64: "",
  };

  // const [certObj, setCertObj] = useState(defaultCertObj);

  let defaultNokObj = {
    firstName: "",
    surName: "",
    title: "",
    nextKinType: "",
    profileImageurl: "",
    email: "",
    phoneNumber: "",
    address: "",
    relationShip: "",
  };
  // const [nokObj, setNokObj] = useState(defaultNokObj);

  const isObjEmpty = (obj) => {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === "") {
        return false;
      }
    }
    return true;
  };

  const getUserProfile = useCallback(async () => {
    try {
      setLoadingProfile(true);
      const res = await personalData(admToken, user?.staffId);
      if (res.status && res.statusCode === 2) {
        setAccountStatus(res.data.status);
        localStorage.setItem("profileAccountStatus", res.data.status);
      } else {
        setAccountStatus(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingProfile(false);
    }
  }, [admToken, user?.staffId]);

  useEffect(() => {
    getUserProfile();
  }, []);

  const getProfile = useCallback(async () => {
    try {
      setLoadingBioData(true);
      const res = await userStaffProfile(admToken, user?.staffId);
      console.log(res);
      if (res.status && res.statusCode === 2) {
        setBioData(res.data);
      } else {
        setBioData(null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingBioData(false);
    }
  }, [admToken, user?.staffId]);

  const getClasses = useCallback(async () => {
    try {
      const res = await TeacherClasses(admToken, user.schoolId);
      if (res.status && res.statusCode === 2) {
        setClasses(res.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }, [admToken]);

  // const getProfile = useCallback(
  //   async (staffId, schoolId, admToken) => {
  //     try {
  //       const endpoint = `https://lasmabadmindev.azurewebsites.net/api/v1/MySchool/ViewStaff-Details?schoolId=${schoolId}&staffId=${staffId}`;

  //       const res = await axios.get(endpoint, {
  //         headers: {
  //           Authorization: `Bearer ${admToken, token}`,
  //         },
  //       });

  //       if (res.data.status === true && res.data.statusCode === 2) {
  //         setBioData(res.data.data);
  //       } else {
  //         setBioData(null);
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }, [admToken]
  // );

  // useEffect(() => {
  //   if (user?.staffId && user?.schoolId) {
  //     getProfile(user.staffId, user.schoolId, admToken);
  //   }
  // }, [admToken, user.staffId, user.schoolId, getProfile]);

  const addProfile = async (obj, type, setObj, defaultObj) => {
    let formIsValid = isObjEmpty(obj);
    if (!formIsValid) {
      return toast.error("Please Make Sure You Fill All The Form");
    }
    setFormLoading(true);

    // console.log(obj);
    try {
      const res = await addUserInformation(admToken, obj, type);
      console.log(res);
      res.status &&
        res.statusCode === 2 &&
        setObj(Object.assign({}, defaultObj));
      res.status &&
        res.statusCode === 2 &&
        toast.success(res.message, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        }) &&
        getProfile();

      (res.status === 400 || res.status === 500) &&
        ErrorService.displayErrorAlert(res.data);
      setFormLoading(false);
    } catch (error) {
      console.log(error);
      setFormLoading(false);
    }
  };

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  useEffect(() => {
    getClasses();
  }, []);

  const handleSubmit = async () => {
    try {
      const payload = {
        status: 5,
        staffIds: [user?.staffId],
      };
      setLoadingUploading(true);
      const res = await updateStatus(admToken, payload);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        getProfile();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUploading(false);
    }
  };

  if (loading) {
    return (
      <>
        <GlobalStyles />
        <Loader />
      </>
    );
  }

  return (
    <>
      <GlobalStyles />
      <Box>
        <Title title="My Profile" />
      </Box>
      <TabContainer>
        <TabLinkContainer>
          <TabLink
            isActive={tab === 6}
            onClick={() => setTab(6)}
            minWidth="15%"
          >
            <p>User Information</p>
          </TabLink>
          <TabLink
            isActive={tab === 1}
            onClick={() => setTab(1)}
            minWidth="15%"
          >
            <p>Personal Data</p>
          </TabLink>{" "}
          {/* <TabLink
            isActive={tab === 2}
            onClick={() => setTab(2)}
            minWidth="15%"
          >
            <p>
              Educational <span className="block">Qualification</span>
            </p>
          </TabLink>{" "} */}
          <TabLink
            isActive={tab === 3}
            onClick={() => setTab(3)}
            minWidth="15%"
          >
            <p>
              Experience <span className="block">History</span>
            </p>
          </TabLink>{" "}
          <TabLink
            isActive={tab === 4}
            onClick={() => setTab(4)}
            minWidth="15%"
          >
            <p>Certifications</p>
          </TabLink>{" "}
          <TabLink
            isActive={tab === 5}
            onClick={() => setTab(5)}
            minWidth="15%"
          >
            <p>Next of Kin</p>
          </TabLink>{" "}
          <TabLink
            isActive={tab === 7}
            onClick={() => setTab(7)}
            minWidth="15%"
          >
            <p>Employee Reference Form</p>
          </TabLink>{" "}
          <TabLink
            isActive={tab === 8}
            onClick={() => setTab(8)}
            minWidth="15%"
          >
            <p>Attachments</p>
          </TabLink>{" "}
          <TabLink
            isActive={tab === 9}
            onClick={() => setTab(9)}
            minWidth="15%"
          >
            <p>Requests</p>
          </TabLink>
        </TabLinkContainer>
        {bioData !== null && (
          <TabContent>
            {tab === 6 && (
              <UserInformation
                data={bioData.userInformation}
                myClasses={classes}
              />
            )}
            {tab === 1 && <Personal status={accountStatus} />}
            {/* {tab === 2 && (
              <Education
                data={bioData.educations}
              />
            )} */}
            {tab === 3 && <Experience status={accountStatus} />}
            {tab === 4 && <Certifications status={accountStatus} />}
            {tab === 5 && <NOK status={accountStatus} />}
            {tab === 7 && <EmployeeReferenceForm status={accountStatus} />}
            {tab === 8 && <AttachmentsSection status={accountStatus} />}
            {tab === 9 && <Request />}
          </TabContent>
        )}

        {loadingBioData ? (
          <div className="flex items-center justify-center my-10">
            <TableLoader />
          </div>
        ) :
          
          ((bioData === null) && (
          <SmallHeader
            style={{
              textAlign: "center",
              fontWeight: "bold",
              color: colors.primary,
              marginTop: "0.4rem",
            }}
          >
            No Staff Information, Please Try Again Later!!!
          </SmallHeader>
          ))}
      </TabContainer>
      {(tab === 8 && (accountStatus === 4 || accountStatus === 0)) && (
        <div className="flex items-center justify-end my-7">
          <button
            onClick={handleSubmit}
            disabled={loadingUploading}
            className="px-8 py-2.5 rounded-lg text-white bg-primary"
          >
            {loadingUploading ? "submitting" : "Submit"}
          </button>
        </div>
      )}
    </>
  );
};

export default Profile;
